import actionCreatorFactory from "typescript-fsa";
import { bindThunkAction } from "typescript-fsa-redux-thunk";

import i18n from "../../lib/i18n";
import { RootState } from "../../state";
import { UnknownError } from "../../common/actions/VisitApi";
import { isFailure } from "../../common/actions/VisitApi";
import { requestToLoadProviders, requestToCreateSupport, CreateSupportParams, Provider, ProviderNames } from "../api";

export { Provider, ProviderNames } from "../api";

const actionCreator = actionCreatorFactory("PROJECT_SUPPORTS");

export const loadProviders = actionCreator.async<RootState, null, Provider[], UnknownError>("PROVIDERS_LOADED");
export const loadProvidersWorker = bindThunkAction(loadProviders, async (params, dispatch) => {
  const req = requestToLoadProviders(params);
  const res = await dispatch(req);
  if (isFailure(res)) {
    throw res.payload.body;
  }
  return res.payload.body;
});

export const authSucceeded = actionCreator<ProviderNames>("AUTH_SUCCEEDED");

export type CreateSupportParams = CreateSupportParams;
export const createSupport = actionCreator.async<RootState, CreateSupportParams, null, UnknownError>("CREATED");
export const createSupportWorker = bindThunkAction(createSupport, async (params, dispatch, getState) => {
  const req = requestToCreateSupport(params);
  const res = await dispatch(req);
  const locale = getState().auth.locale;
  if (isFailure(res)) {
    (window as any).notify_bar(i18n.translate("notify_bar.network_error", { locale }), true);
    throw res.payload.body;
  }
  (window as any).notify_bar(i18n.translate("project_supports.complete", { locale }));
  if (process.env.NODE_ENV === "production") {
    (window as any).ga("send", "event", "support", "success", params.projectId);
  }
  return null;
});



// WEBPACK FOOTER //
// ./frontend/src/project_supports/actions/index.ts